<div class="gallery-two-wrapper">
    <div *ngFor="let item of items;let i = index" class="gallery-two-box gallery-two-box-{{i + 1}}">
        <img onError="this.src='assets/img/img-not-available.png';" 
            [src]="item?.media?.url" 
            [alt]="item?.media?.altText ? item?.media?.altText : ''"  
            [title]="item?.media?.title ? item?.media?.title : ''" />
    </div>
</div>